import type { ReactNode } from 'react';

import { ClassNames } from '@/shared/classNames';

export type KeyValueItem = {
  key: string;
  label: ReactNode;
  value: ReactNode;
};

export const KeyValueGrid = ({ className, items }: { className?: string; items: KeyValueItem[] }) => (
  <dl className={ClassNames('grid gap-2 text-sm md:grid-cols-2 xl:grid-cols-4', className)}>
    {items.map((item) => (
      <div className="border-line bg-raised/55 rounded-md border p-3" key={item.key}>
        <dt className="text-muted text-xs font-semibold">{item.label}</dt>
        <dd className="text-ink mt-1 font-medium break-words">{item.value ?? 'n/a'}</dd>
      </div>
    ))}
  </dl>
);

export const DetailList = ({ className, items }: { className?: string; items: KeyValueItem[] }) => (
  <dl className={ClassNames('text-ink grid gap-2 text-sm', className)}>
    {items.map((item) => (
      <div className="border-line grid min-w-0 gap-1 rounded-md border p-3 sm:grid-cols-[10rem_minmax(0,1fr)]" key={item.key}>
        <dt className="text-muted text-xs font-semibold">{item.label}</dt>
        <dd className="text-ink min-w-0 [overflow-wrap:anywhere]">{item.value ?? 'n/a'}</dd>
      </div>
    ))}
  </dl>
);
